/*
 * This program is part of an OpenCms Template.
 *
 * Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// the global objects that must be passed to this module
var jQ;
var DEBUG;

var m_fixedHeader = null;

var m_$anchor = null;


function resetSubMenus($topmenu, $submenu) {
    $topmenu.find(".dropdown-submenu").each(function(i) {
        var $this = jQ(this);
        if (!($submenu && jQ.contains(this, $submenu))) {
            $this.removeClass("open");
            $this.removeClass("open-left");
            $this.removeClass("open-right");
            $this.find(".dropdown-menu").first().css("right", "");
            $this.find(".dropdown-toggle").first().attr("aria-expanded", "false");
        }
    });
}

function setKeyboardClass(active) {
    if (active) {
        jQ(document.documentElement).addClass('ap-keyboard-nav');
    } else {
        jQ(document.documentElement).removeClass('ap-keyboard-nav');
    }
}

function toggleTopmenu($dropdown, open) {
    var isOpen = $dropdown.hasClass("open");
    if ((open && !isOpen) || (!open && isOpen)) {
        var $toggle = $dropdown.find(".dropdown-toggle").first();
        var $menu = $dropdown.find(".dropdown-menu").first();
        // for the top level we use the bootstrap native method
        $toggle.dropdown("toggle");
        resetSubMenus($dropdown);
        if ($menu.offset().left + $menu.outerWidth() > Apollo.windowWidth()) {
            // this menu must open left
            $dropdown.addClass("open-left");
        } else {
            $dropdown.removeClass("open-left");
        }
    }
}

function toggleSubmenu($dropdown, event) {
    var $toggle = $dropdown.find(".dropdown-toggle").first();
    if (!$dropdown.hasClass("open")) {
        var $menu = $dropdown.find(".dropdown-menu").first();
        var openLeft = $dropdown.closest('.open-left').length > 0;
        var openRight = $dropdown.closest('.open-right').length > 0;
        resetSubMenus($dropdown.closest('.dropdown.ap-nav-header'), $toggle.get(0));
        // open the menu
        $dropdown.addClass("open");
        $toggle.attr("aria-expanded", "true");
        if (openRight || (openLeft && ($menu.offset().left - $menu.outerWidth() <= 0))) {
            // we have opened left to far, open to the right again
            openLeft = false;
            $dropdown.addClass("open-right");
        } else if (openLeft || ($menu.offset().left + $menu.outerWidth() > Apollo.windowWidth())) {
            // this menu must open left, the right corner is outside window
            $dropdown.addClass("open-left");
            var $parent = $dropdown.parent();
            if ($parent.outerWidth() > Math.floor(parseFloat($parent.css("min-width")))) {
                // parent is wider than min-width from CSS, adjust right position
                $menu.css("right", $parent.outerWidth());
            }
        }
    } else if (event.type == "click") {
        $dropdown.removeClass("open");
        $toggle.attr("aria-expanded", "false");
    }
    event.preventDefault();
    event.stopPropagation();
}

// Elements in head navigation
function initHeadNavigation() {

    // The search button
    jQ('.head .navbar-nav .search').on('click', function(e) {
        if (jQ('.search-btn').hasClass('fa-search')) {
            jQ('.search-open').fadeIn(500);
            jQ('.search-btn').removeClass('fa-search');
            jQ('.search-btn').addClass('fa-times');
        } else {
            jQ('.search-open').fadeOut(500);
            jQ('.search-btn').addClass('fa-search');
            jQ('.search-btn').removeClass('fa-times');
        }
    });

    // Hover Selector used for language switch
    jQ('.hoverSelector').on('mouseenter mouseleave', function(e) {

        jQ('.hoverSelectorBlock', this).toggleClass('show');
        e.stopPropagation();
    });

    // Show / hide top level menu on hover
    jQ('.dropdown.ap-nav-header, .dropdown.ap-languages').on('mouseenter mouseleave', function(e) {

        if (Apollo.gridInfo().isMinMd()) {
            toggleTopmenu(jQ(this), e.type == "mouseenter");
        }
    });

    // Support for using a top level menu item for opening the menu AND direct linking
    jQ('.dropdown.ap-nav-header > .dropdown-toggle.nav-handle').on('keydown touchstart', function(e) {

        if (Apollo.gridInfo().isMinMd() && !(e.type == "keydown" && e.which == 9)) {
            // setting the "open" class on the parent will trigger display:none on this element
            toggleTopmenu(jQ(this).parent(), true);
            e.preventDefault();
            e.stopPropagation();
        }
    });

    // Show sub-menu on hover
    jQ('.dropdown.ap-nav-header .dropdown-submenu').on('mouseenter', function(e) {

        if (Apollo.gridInfo().isMinMd()) {
            toggleSubmenu(jQ(this), e);
        }
    });

    // Show sub-menu on click for mobile
    jQ('.dropdown.ap-nav-header .dropdown-submenu > .nav-trigger').on('click', function(e) {

        if (! Apollo.gridInfo().isMinMd()) {
            toggleSubmenu(jQ(this).parent(), e);
        }
    });

    // Support for sub-menu click navigation (for keyboard users)
    jQ('.dropdown.ap-nav-header .dropdown-submenu .dropdown-toggle').on('keydown touchstart', function(e) {

        if (Apollo.gridInfo().isMinMd() && !(e.type == "keydown" && e.which == 9)) {
            toggleSubmenu(jQ(this).parent(), e);
        }
    });

    // Add handler for elements that should not keep the focus
    jQ('[data-toggle], .blur-focus').on('mouseleave', function(e) {

        jQ(this).blur();
    });

    // Responsive navbar toggle button
    jQ('.head-toggle .nav-toggle').click(function() {
        jQ('.head-toggle .nav-toggle').toggleClass('active');
        jQ(document.documentElement).toggleClass('active-nav');
    });

    // If user presses tab, add marker class to document body to enable focus highlighting
    jQ(document.documentElement).on('keydown', function(e) {

        if (e.which == 9) {
            setKeyboardClass(true);
        }
    });

    // If the mouse is moved, remove focus highlight marker class
    jQ(document.documentElement).on('mousemove', function(e) {

        setKeyboardClass(false);
    });

    // Swipe to show menu - disabled
    if (false && window.apolloPluginsJQueryTouch && Apollo.gridInfo().navPos() != "top") {
        jQ('#apollo-page').on('swipe', function(e, touch) {
            if (Apollo.gridInfo().isMobileNav()) {
                var showNav = Apollo.gridInfo().navPos() == "right" ? "left" : "right";
                var hideNav = Apollo.gridInfo().navPos() == "right" ? "right" : "left";
                if (touch.direction == showNav) {
                    jQ('.head-toggle .nav-toggle').addClass('active');
                    jQ(document.documentElement).addClass('active-nav');
                } else if (touch.direction == hideNav) {
                    jQ('.head-toggle .nav-toggle').removeClass('active');
                    jQ(document.documentElement).removeClass('active-nav');
                }
            }
        });
    }

    // Fixed top navbar header
    var $header = jQ('.ap-header');
    if ($header.length > 0) {
        var $fixedHeader = $header.first().find('.sticky');
        if ($fixedHeader.length > 0) {
            if (DEBUG) console.info("Fixed header element found!");
            m_fixedHeader = {};
            m_fixedHeader.$parent = $fixedHeader.first();
            m_fixedHeader.$element = $fixedHeader.find('.head').first();
            m_fixedHeader.$element.addClass('notfixed');
            m_fixedHeader.isFixed = false;
            m_fixedHeader.getHeight = function () {
                return this.height > 0 ? this.height : this.$element.height();
            }
            jQ(window).on('scroll', debUpdateFixedScroll).on('resize', debUpdateFixedResize);
            updateFixed(null);
        } else {
            if (DEBUG) console.info("Fixed header element NOT found!");
        }
    };
}

function updateFixed(event) {
    var verbose = true;
    // Update position of fixed header.
    // This is more complicated then it appears since the fixed header height
    // can be different from the attached header height, e.g. if a class '.hidden-fixed' is used.
    // In order to correctly calculate anchor link positions we must make sure to use the correct
    // header height depending on the page scroll state.
    var resize = (event == null) ? true : event.type == 'resize';
    if (Apollo.gridInfo().isMinMd()) {
        if (DEBUG && verbose) console.info("Fixed header update, isDesktopNav=true");
        // assuming this event handler is only called if m_fixedHeader != null
        // only do this if screen size MD or LG
        if (resize) {
            m_fixedHeader.bottom = m_fixedHeader.$parent.offset().top + m_fixedHeader.$parent.height();
        }
        var fixHeader = m_fixedHeader.bottom < (Apollo.windowScrollTop() + Apollo.toolbarHeight());
        if (DEBUG && verbose) console.info("Fixed header update, fixHeader=" + fixHeader + " m_fixedHeader.isFixed=" + m_fixedHeader.isFixed);
        if (fixHeader && !m_fixedHeader.isFixed) {
            // header should be fixed, but is not
            m_fixedHeader.isFixed = true;
            m_fixedHeader.$parent.height(m_fixedHeader.$element.height());
            m_fixedHeader.$element.removeClass('notfixed').addClass('isfixed animated fadeInDown');
            m_fixedHeader.height = m_fixedHeader.$element.height();
        } else if (!fixHeader && m_fixedHeader.isFixed) {
            // header should not be fixed, but is
            m_fixedHeader.isFixed = false;
            m_fixedHeader.$element.removeClass('isfixed animated fadeInDown').addClass('notfixed');
            m_fixedHeader.$parent.height("auto");
        } else {

        }
        if (resize) {
            // resize may lead to changes in the header height, make sure we don't use outdated valued
            m_fixedHeader.height = m_fixedHeader.isFixed ? m_fixedHeader.$element.height() : -1;
            if (DEBUG && verbose) console.info("Header is " + (m_fixedHeader.isFixed ? "" : "NOT ") + "fixed, fixed height: " + m_fixedHeader.getHeight());
        }
    } else {
        // smaller screens: make sure the head height is set to "auto"
        if (DEBUG && verbose) console.info("Fixed header update, isDesktopNav=false");
        if (resize && m_fixedHeader.isFixed) {
            m_fixedHeader.isFixed = false;
            m_fixedHeader.$element.removeClass('isfixed animated fadeInDown').addClass('notfixed');
            m_fixedHeader.$parent.height("auto");
        }
    }
}

function fixedHeaderActive() {

    return (m_fixedHeader != null) && Apollo.gridInfo().isMinMd();
}

// add click handler and adjust position on initial page load
function initSmoothScrolling() {

    // attach click handler to anchor links on the page
    jQ('a[href*="#"]:not([href="#"]):not([data-toggle]):not([data-slide])').click(function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var $target = jQ(this.hash);
            if ($target.length) {
                jQ(this).blur();
                scrollToAnchor($target);
                return false;
            }
        }
    });

    // for initial page load, make sure we adjust scroll position for fixed header and OpenCms toolbar
    if (location.hash.length) {
        if (DEBUG) console.info("Initial anchor (location.hash): " + location.hash);
        scrollToAnchor(jQ(location.hash));
    }
}


// Clickme-Showme effect sections
function initClickmeShowme() {

    var $clickSections = jQ('.clickme-showme');
    if (DEBUG) console.info(".clickme-showme elements found: " + $clickSections.length);
    $clickSections.each(function() {

        var $element = jQ(this);
        var $clickme = $element.find('> .clickme');
        var $showme  = $element.find('> .showme');

        if (DEBUG) console.info("initClickmeShowme called for " + $clickme.getFullPath());

        $clickme.click(function() {
            $clickme.slideUp();
            $showme.slideDown();
        });

        $showme.click(function() {
            $showme.slideUp();
            $clickme.slideDown();
        });
    });
}


// match-height sections
function initMatchHeight() {

    var $mhSections = jQ('.match-height');
    if (DEBUG) console.info(".match-height elements found: " + $mhSections.length);
    if ($mhSections.length > 0) {
        $mhSections.matchHeight();
    }
    var $shSections = jQ('.same-height .ap-section');
    if (DEBUG) console.info(".same-height .ap-sections found: " + $shSections.length);
    if ($shSections.length > 0) {
        $shSections.matchHeight();
    }
}


// apply "external" class to all a href links
function initExternalLinks() {

    var $aHrefs = jQ('.ap-section a');
    if (DEBUG) console.info("a elements found in .ap-sections: " + $aHrefs.length);
    if (DEBUG) console.info("location.hostname is: " + location.hostname);
    try {
        if (! Apollo.isEditMode()) {
            $aHrefs.each(function() {

                var $element = jQ(this);
                var hostname = $element.prop("hostname");
                if (hostname && hostname !== location.hostname) {
                    $element.addClass("external");
                }
            });
        } else {
            if (DEBUG) console.info("skipped external a element extension because of edit mode");
        }
    } catch (err) {
        // required otherwise IE may prodice an error and stop execution
        console.info("initExternalLinks() Error " + err);
    }
}

// functions that require the Apollo object
var debUpdateFixedResize;
var debUpdateFixedScroll;
var debScrollToAnchor;

function initApolloDependencies() {

    debUpdateFixedResize = Apollo.debounce(function() {
        updateFixed(true)
    }, 25, true);

    debUpdateFixedScroll = Apollo.debounce(function() {
        updateFixed(false)
    }, 25);

    debScrollToAnchor = Apollo.debounce(function($anchor, offset) {
        if ($anchor.length) {
            offset = offset || 0;
            var targetTop = $anchor.offset().top + offset;
            if (DEBUG) console.info("scrollToAnchor(#" + $anchor.attr('id') + ") position:" + targetTop);
            if (fixedHeaderActive() && (targetTop > m_fixedHeader.bottom)) {
                if (m_fixedHeader.height < 0) {
                    // fixed header height is unknown, i.e. page was not scrolled down so far
                    // jump to header bottom to activate the fixed header first
                    if (targetTop > m_fixedHeader.bottom) {
                        jQ('html, body').scrollTop(m_fixedHeader.bottom - Apollo.toolbarHeight() + 1);
                        updateFixed(true);
                    }
                }
                targetTop = targetTop - m_fixedHeader.getHeight();
                if (DEBUG) console.info("scrollToAnchor(#" + $anchor.attr('id') + ") adjusting position to:" + targetTop);
            }
            var page = $("html, body");
            // see: https://stackoverflow.com/questions/18445590/jquery-animate-stop-scrolling-when-user-scrolls-manually
            page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                page.stop();
            });
            page.animate({ scrollTop: Math.ceil(targetTop - Apollo.toolbarHeight()) }, 1000, function(){
                page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });
        }
    }, 500, true);
}

/****** Exported functions ******/

//Smooth scrolling to anchor links
export function scrollToAnchor($anchor, offset) {
    if ($anchor.length) {
        // m_$anchor = $anchor;
        debScrollToAnchor($anchor, offset);
        // m_$anchor = null;
    }
}

export function init(jQuery, debug) {

    jQ = jQuery;
    DEBUG = debug;

    if (DEBUG) console.info("ApolloNavigation.init()");

    initApolloDependencies();
    initHeadNavigation();
    initMatchHeight();
    initSmoothScrolling();
    initClickmeShowme();
    initExternalLinks();
}

